import { createContext } from 'react';

import { ApolloContextType } from '../../types';

// ----------------------------------------------------------------------

export const AuthContext = createContext({} as ApolloContextType);
